import { styled, DialogTitle } from "@mui/material";

export const DialogHeader = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ebec;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 24px;
`;
